<div class="h-screen w-full overflow-hidden">
    <div class="h-full w-full flex flex-col md:flex-row">
        <!-- Left panel: Intro (Adaptive Flex) -->
        <section class="hidden md:flex flex-1 relative h-full">
            <app-auth-intro badge="Sistema de Gestión Odontológica" title="Protegiendo tu práctica"
                subtitle="La autenticación de doble factor añade una capa quirúrgica de seguridad a tu información médica."
                actionText="¿Problemas con el código?"
                tip="Mantén tu dispositivo móvil a mano para recibir el código de verificación al instante."
                [actionFn]="handleHelp" class="w-full"></app-auth-intro>
        </section>

        <!-- Right panel: Form Area - Absolute Luminous Theme -->
        <section
            class="w-full md:w-[45%] lg:w-[40%] xl:w-[35%] flex flex-col h-full bg-white dark:bg-slate-900 relative overflow-hidden">
            <app-auth-header class="px-8 pt-4" [showBack]="true"></app-auth-header>

            <div class="flex-1 flex flex-col p-8 lg:p-14 xl:p-16">
                <!-- Master Content: Architectural Layout -->
                <div class="flex-1 flex flex-col justify-center w-full max-w-xl mx-auto">
                    <div class="space-y-12">
                        <!-- Welcoming Area -->
                        <div class="text-left animate-slide-up">
                            <div class="inline-flex items-center gap-2 mb-4 text-primary opacity-80">
                                <div class="w-6 h-[1.5px] bg-primary/40"></div>
                                <span class="text-[15px] font-black uppercase tracking-[0.4em]">Verificación 2FA
                                </span>
                            </div>
                            <p
                                class="text-text-muted dark:text-slate-500 font-bold text-xs lg:text-[11px] leading-relaxed max-w-sm border-l-2 border-primary/10 pl-6">
                                Ingresa los 6 dígitos enviados a tu dispositivo configurado.
                            </p>
                        </div>

                        <!-- OTP Input -->
                        <div class="grid grid-cols-1 gap-6">
                            <app-input-otp #otpInput [length]="6" (valueChange)="onCodeComplete($event)"></app-input-otp>

                            <!-- Actions -->
                            <div class="pt-6 space-y-4">
                                <app-button [fullWidth]="true" size="lg" type="button" (btnClick)="verify()"
                                    [loading]="loading" iconRight="mdi:arrow-right"
                                    class="shadow-[0_15px_30px_rgba(74,144,226,0.1)] hover:shadow-primary/20 dark:hover:shadow-primary/30 transform active:scale-[0.98] transition-all rounded-xl py-5 text-base uppercase tracking-[0.2em] font-black">
                                    Validar Identidad
                                </app-button>

                            </div>
                        </div>

                        <!-- Error (Alerta In-Situ con Shake Effect) -->
                        <div *ngIf="errorMessage"
                            class="p-4 bg-red-500/10 rounded-xl border border-red-500/30 flex items-center gap-3 text-xs font-black text-red-600 dark:text-red-400 animate-shake">
                            <div class="w-1.5 h-6 bg-red-500 rounded-full"></div>
                            <div class="flex-1">
                                <span class="uppercase tracking-widest">{{ errorMessage }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="px-8 pb-4 text-left">
                <p class="text-[9px] font-black tracking-[0.3em] text-text-muted uppercase">
                    Dentium Platform v1.0.4
                </p>
            </div>
        </section>
    </div>
</div>